import React, {useEffect, useState} from 'react'
import {
  Button,
  Layout,
  Table,
  message,
  Spin,
  Space, DatePicker, Popover, Statistic
} from 'antd';
import { useNavigate, useParams} from "react-router-dom";
import { FileExcelOutlined} from "@ant-design/icons";
import _ from "lodash";
import dayjs from "dayjs";
import TableTitle from "../../base/TableTitle";
import {ToernIcon} from "../../icons/CustomIcons";
import sfnService from "../../../services/SFNService";

const { Content } = Layout;

const hfnFmt = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

const SFNUebersichtliste = () => {
  let {pJahr} = useParams();
  const navigate = useNavigate();

  const [messageApi, contextHolder] = message.useMessage();

  const [jahr, setJahr] = useState(pJahr ? pJahr : dayjs().get('year'));
  const [benutzerliste, setBenutzerliste] = useState([]);
  const [loading, setloading] = useState(true);
  const [feldFilter, setFeldFilter] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");

  const error = (msg) => {
    messageApi.open({
      type: 'error', content: msg,
    });
  }

  useEffect(() => {
    getBenutzerliste();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jahr]);

  const getBenutzerliste = async () => {
    setloading(true);
    await sfnService.getSFNUebersicht(jahr).then(
      res => {
        setloading(false);
        setBenutzerliste(
          res.data.map(row => ({
            key: `t_${row.benutzer.id}`,
            benutzer: row.benutzer,
            zuschlaege: row.zuschlaege,
            id: row.benutzer.id,
          }))
        );
      }
    ).catch((e) => {
      error(`Beim Laden der Benutzer ist ein Fehler aufgetreten`);
      console.error(e);
    });
  };

  const filterData = benutzerliste => formatter => benutzerliste.map( item => ({
    text: formatter(item),
    value: formatter(item)
  }));

  const handleChange = (pagination, filters, sorter) => {
    setFeldFilter(filters);
  };

  const changeJahr = (ev) => {
    setJahr(ev ? dayjs(ev.$d).year() : dayjs().year() )
  }

  const tabletitle = () => {
    return <TableTitle icon={<ToernIcon/>}
                  filtervalues={
                    benutzerliste
                      .reduce(function(acc, b) {
                        acc.push(b.benutzer.vorname);
                        acc.push(b.benutzer.nachname);
                        return acc;
                      }, [])
                    .filter((value, index, array) => array.indexOf(value) === index)
                    .map(s => ({ label: s, value: s}))
                  }
                  onFilter={setGlobalFilter} >SFN-Übersicht {jahr}</TableTitle>
  }

  const columns=[

    {
      title: 'Vorname',
      dataIndex: 'benutzer',
      key: 'benutzerVorname',
      sorter: (a, b) => a.benutzer.vorname.localeCompare(b.benutzer.vorname),
      filters: _.uniqWith(filterData(benutzerliste)(i => i.benutzer.vorname), _.isEqual),
      filteredValue: feldFilter.benutzerVorname || null,
      onFilter: (value, record) => record.benutzer.vorname.includes(value),
      render: (benutzer) => <>{benutzer.vorname}</>
    },
    {
      title: 'Nachname',
      dataIndex: 'benutzer',
      key: 'benutzerNachname',
      sorter: (a, b) => a.benutzer.nachname.localeCompare(b.benutzer.nachname),
      filters: _.uniqWith(filterData(benutzerliste)(i => i.benutzer.nachname), _.isEqual),
      filteredValue: feldFilter.benutzerNachname || null,
      onFilter: (value, record) => record.benutzer.nachname.includes(value),
      render: (benutzer) => <>{benutzer.nachname}</>
    },
    {
      title: 'Rang',
      dataIndex: 'benutzer',
      key: 'benutzerRang',
      filteredValue: globalFilter ? [globalFilter] : null,
      onFilter: (value, record) =>
        record.benutzer.vorname.toString().toLowerCase().includes(value.toLowerCase()) ||
        record.benutzer.nachname.toString().toLowerCase().includes(value.toLowerCase())
      ,

      render: (benutzer) => <>{benutzer.rang==='Kapitaen' ? "Kapitän" : benutzer.rang}</>
    },
  ]

  let MONATE = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]

  for(let i=0; i<12; i++) {
    columns.push(
      {
        title: MONATE[i],
        dataIndex: 'zuschlaege',
        key: 'zuschlaege' + i,
        align: 'right',
        render: (z) => <Popover title="Zuschläge" trigger="hover"
                                content={<>
                                  <Statistic title="Zuschlag (Tarif)" value={z[i].tarifZuschlag} precision={2} />
                                  <Statistic title="Zuschlag (gezahlt)" value={z[i].benutzerZuschlag} precision={2} />
                                  <Statistic title="Zuschlag (gefahren)" value={z[i].toernZuschlag} precision={2} />
                                </>}
        >
          <div>{z[i] ? (z[i].toernZuschlag - z[i].benutzerZuschlag).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2}) : 0}</div>
        </Popover>
      },
    )
  }


  return (
    <>
      {contextHolder}
      <Layout>
        <Layout.Header style={{ backgroundColor: "#cccccc", display: 'flex',  alignItems: 'center'}}>
          <Space>
            <DatePicker defaultValue={dayjs()} format={'YYYY'} picker="year"
                        onChange={ changeJahr } />
            <Button icon={<FileExcelOutlined />} href={`/excel/sfn-uebersicht-${jahr}.xlsx`} target={"_blank"}><span className="buttonLabel">Excel</span></Button>
          </Space>
        </Layout.Header>
        <Content>
          {loading ? (
            <div style={{ padding: '16px' }}>
              <Spin size="large" />
            </div>
          ) : (
            <Table title={tabletitle} size={"small"} columns={columns} dataSource={benutzerliste} onChange={handleChange}></Table>
          )}
        </Content>
      </Layout>
    </>
  )
}

export default SFNUebersichtliste